import React from "react";
import { MdOutlineStar, MdOutlineStarBorder, MdOutlineStarHalf } from "react-icons/md";

interface StarRatingProps {
    rating: number; // Rating value (e.g., 4.92)
    size?: number; // Size of the star icons (default is 18px)
    color?: string; // Color of the stars (default is "#f7a002")
    maxRating?: number; // Maximum possible rating (default is 5)
    starCount?: number; // Number of stars to display (default is 5)
    fullStarIcon?: React.ReactNode; // URL or icon for full stars
    halfStarIcon?: React.ReactNode; // URL or icon for half stars
    emptyStarIcon?: React.ReactNode; // URL or icon for empty stars
}

export const StarRating: React.FC<StarRatingProps> = ({
    rating = 0,
    size = 18,
    color = "#f7a002",
    maxRating = 5,
    starCount = 5,
    fullStarIcon,
    halfStarIcon,
    emptyStarIcon,
}) => {
    // Calculate the number of full stars
    const fullStars = Math.floor(rating);

    // Check if there's a half star
    const hasHalfStar = rating % 1 >= 0.5;

    // Calculate the number of empty stars
    const emptyStars = starCount - fullStars - (hasHalfStar ? 1 : 0);

    return (
        <span className="star-rating">
            {/* Render full stars */}
            {[...Array(fullStars)].map((_, index) => fullStarIcon || (
                <MdOutlineStar key={index} size={size} color={color} />
            ))}

            {/* Render half star if needed */}
            {hasHalfStar && (halfStarIcon || <MdOutlineStarHalf size={size} color={color} />)}

            {/* Render empty stars */}
            {[...Array(emptyStars)].map((_, index) => emptyStarIcon || (
                <MdOutlineStarBorder key={index} size={size} color={color} />
            ))}

            {/* Display the rating as text */}
            {/* <span className="rating-text">{rating.toFixed(2)} / {maxRating}</span> */}
        </span>
    );
};
